import { Injectable } from '@angular/core';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import {
  DabConfigurationKeys,
  DAB_FEATURE_NAME,
} from '@epicuro-next/state/dab-state';
import { ComponentStore } from '@ngrx/component-store';
import { filter, take } from 'rxjs/operators';

export interface ConfigStripUiState {
  isOpenInboundDetails: boolean;
}

const initialState: ConfigStripUiState = {
  isOpenInboundDetails: false,
};

@Injectable()
export class ConfigStripUiStore extends ComponentStore<ConfigStripUiState> {
  public readonly isOpenInboundDetails$ = this.select(
    (state) => state.isOpenInboundDetails,
  );

  private readonly inboundDetailsTurnedOn$ = this.configService.getConfigValue({
    namespace: DAB_FEATURE_NAME,
    featureName: DabConfigurationKeys.InboundDetailsTurnedOn,
    defaultValue: false,
  });

  constructor(private configService: ConfigurationsService) {
    super(initialState);
  }

  public setInboundDetailsVisibility(value: boolean) {
    this.inboundDetailsTurnedOn$
      .pipe(take(1), filter(Boolean))
      .subscribe(() => {
        this.patchState((state) => {
          return {
            state,
            isOpenInboundDetails: value,
          };
        });
      });
  }
}
